// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2Y5Lf","content":"GlobalSearch_content__1wCwX"};